import {
  REQUEST_ADD_ROUTE_LOGISTIC_TRIP,
  RESPONSE_ADD_ROUTE_LOGISTIC_TRIP,
  REQUEST_ADD_ROUTE_LOGISTIC_TRIP_FAILURE,
  REQUEST_DELETE_ROUTE_LOGISTIC_TRIP,
  RESPONSE_DELETE_ROUTE_LOGISTIC_TRIP,
  REQUEST_DELETE_ROUTE_LOGISTIC_TRIP_FAILURE,
  REQUEST_ALARM_ROUTE_LOGISTIC_TRIP,
  REQUEST_ALARM_ROUTE_LOGISTIC_TRIP_FAILURE,
  RESPONSE_ALARM_ROUTE_LOGISTIC_TRIP,
} from "../actions/logisticTripRoutesActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  logisticAddTripRouteDataState: queriesStates.NOT_REQUESTED,
  logisticDeleteTripRouteDataState: queriesStates.NOT_REQUESTED,
  logisticUpdateTripRouteAlarmDataState: queriesStates.NOT_REQUESTED,
  errors: [],
};

const logisticTripRoutesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ADD_ROUTE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticAddTripRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_ADD_ROUTE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticAddTripRouteDataState: queriesStates.READY,
      });
    }
    case REQUEST_ADD_ROUTE_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticAddTripRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_ROUTE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticDeleteTripRouteDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_ROUTE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticDeleteTripRouteDataState: queriesStates.READY,
      });
    }
    case REQUEST_DELETE_ROUTE_LOGISTIC_TRIP_FAILURE: {
      return Object.assign({}, state, {
        logisticDeleteTripRouteDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_ALARM_ROUTE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticUpdateTripRouteAlarmDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_ALARM_ROUTE_LOGISTIC_TRIP: {
      return Object.assign({}, state, {
        logisticUpdateTripRouteAlarmDataState: queriesStates.READY,
      });
    }
    case REQUEST_ALARM_ROUTE_LOGISTIC_TRIP_FAILURE : {
      return Object.assign({}, state, {
        logisticUpdateTripRouteAlarmDataState: queriesStates.FAILURE,
        errors: state.errors.concat(action.errors),
      });
    }

    default:
      return state;
  }
};

export default logisticTripRoutesReducer;
